import FootballCountryModel from "../Country/FootballCountryModel";
import TeamBasicModel from "../Team/TeamBasicModel";

export default class PlayerBasicModel {
    public id: string = '';
    public country: FootballCountryModel = null;
    public birthDate: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public name: string = '';
    public position: string = '';
    public assets: {} = null;
    public isDeleted: boolean = false;
    public teams: TeamBasicModel[] = [];
}
